export const componentStyles = {
  footerContainer: {
  position: "fixed",
  bottom: "0",
  left: "0",
  //width: "100%",
  },
  rowWrapper: { backgroundColor: "#6AAEBA", padding: "10px 0px" },
  responsiveRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headingContainer: { display: "flex", alignItems: "center" },
  fontStyles: { fontSize: "10px", color: "#fff", fontWeight: 700 },
  h100: { height: "100%" },
};
